<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-datepicker
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [label]="props.label"
    [readonly]="props.readonly"
    [dateFormat]="format"
    [hourFormat]="format"
    [showTime]="props.showTime"
    [showButtonBar]="props.showButtonBar"
    [showOtherMonths]="props.showOtherMonths"
    [selectOtherMonths]="props.selectOtherMonths"
    [selectionMode]="props.selectionMode"
    [maxDate]="props.maxDate"
    [minDate]="props.minDate"
    [timeOnly]="props.timeOnly"
    [view]="props.view"
    [showClear]="!props.required"
    [dt]="props.dt"
    [isVertical]="props.isVertical"
    [badgeDisabled]="props.badgeDisabled"
    [showDashIfEmptyAndReadOnly]="props.showDashIfEmptyAndReadOnly"
    [showTimezone]="props.showTimezone"
  >
    @if (props.showTimezone) {
      <ng-template #header>{{ currentTimeZone }}</ng-template>
    }
  </new-ui-datepicker>

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
